import(/* webpackMode: "eager" */ "/app/apps/web/src/app/error.tsx");
